import { NgModule } from '@angular/core';
import { router } from './sessions.routes';
import { ClipboardModule } from 'ngx-clipboard';
import { SessionsListComponent } from './list/sessions-list.component';
import { SessionsCreateComponent } from './create/session-create.component';
import { AuthGuard } from '../auth/auth.guard';
import { HttpModule } from '@angular/http';
import { SessionsService } from './sessions.service';
import { CommonModule } from '@angular/common';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ModalModule } from 'ngx-bootstrap/modal';
import { SessionsComponent } from './sessions.component';
import { SessionsEditComponent } from './edit/session-edit.component';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ArchwizardModule } from 'ng2-archwizard';
import { WizardService } from './wizard/wizard.service';
import { WizardColComponent } from './wizard/wizard-col.component';
import { WizardFormComponent } from './wizard/wizard-form.component';
import { Step3Component } from './create/step/step3.component';
import { PluginsModule } from '../plugins/plugins.module';
import { TabsModule } from '../tabs/tabs.module';
import { CustomizationModule } from '../customization/customization.module';
import { EmailModule } from '../email/email.module';
import { SessionsEmailComponent } from './email/email.component';
import { SessionsFeaturesComponent } from './features/features.component';
import { SessionsUsersComponent } from './users/users.component';
import { SessionsRegistrationComponent } from './registration/registration.component';
import { SessionsCustomizationComponent } from './customization/customization.component';
import { SessionsLinksComponent } from './links/links.component';
import { SessionsLinksComponent2 } from './links-2/links.component';
import { SessionsGenericLoginComponent } from './generic_login/generic_login.component';
import { SessionResolver, SessionsResolver } from './sessions.resolver';
import { IboxtoolsModule } from '../iboxtools/iboxtools.module';
import { ShortUrlService } from './shorturl.service';
import { PhoneNumberService } from './phone-number.service';
import { UsersService } from './users/users.service';
import { KonamiDirective } from '../../directives/konami';
import { GenericLoginComponent } from './create/step/generic_login/generic_login.component';
import { ImageImportModule } from '../image_import/image_import.module';
import { ShowHideComponent } from './generic_login/show-hide.component';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TabsModule as NgxTabsModule } from 'ngx-bootstrap/tabs';
import { NgPipesModule } from 'ngx-pipes';
import { OrderByDatePipe } from './list/order-by-date.pipe';
import { FriendlyPhonePipe } from './edit/friendly-phone.pipe';
import { RepeatPipe } from './users/repeat.pipe';
import { DatePickerModule } from '../date-picker/date-picker.module';
import { RegistrationFormComponent } from './registration/form/form.component';
import { DragulaModule } from 'ng2-dragula';
import { SharedModule } from '../shared/shared.module';
import { SessionsManageMeEventComponent } from './manage-my-event/manage-my-event.component';
import { ReplayPublishComponent } from './replay/replay.component';
import { DecodeUriPipe } from './replay/replay.pipe';
import { ThemeResolver } from '../../theme/theme.resolver';
import { TagInputModule } from 'ngx-chips';
import { FileUploadModule } from 'ng2-file-upload';
import { VideoFileUploadComponent } from './file-upload/video-file-upload.component';
import { VideoService } from './video.service';
import { TagsService } from './tags.service';
import { StatsComponent } from './stats/stats.component';
import { BarChartComponent } from '../bar-chart/bar-chart.component';
import { StatsNumberComponent } from './stats/stats-number/stats-number.component';
import { StatsService } from './stats/stats.service';
import { StatsHistogramComponent } from './stats/stats-histogram/stats-histogram.component';
import { SessionsCertificatesComponent } from './certificates/certificates.component';
import { CertificatesService } from './certificates.service';
import { ParticipantsService } from './participants.service';
import { EventManagerComponent } from './event-manager/event-manager.component';
import { AdditionalConfigurationComponent } from './additional-configuration/additional-configuration.component';
import { TagEditorModule } from '../tag-editor/tag-editor.module';
import { EvaEditorModule } from '../eva-editor/eva-editor.module';
import { SessionsRegistrationFormComponent } from './registration-form/registration-form.component';
import { EditRegistrationFieldComponent } from './registration-form/edit-registration-field/edit-registration-field.component';
import { EditRegistrationFieldValuesComponent } from './registration-form/edit-registration-field-values/edit-registration-field-values.component';
import { EditRegistrationFieldCompanionsComponent } from './registration-form/edit-registration-field-companions/edit-registration-field-companions.component';
import { EditRegistrationFieldConditionsComponent } from './registration-form/edit-registration-field-conditions/edit-registration-field-conditions.component';
import { EditRegistrationFieldSingleConditionComponent } from './registration-form/edit-registration-field-single-condition/edit-registration-field-single-condition.component';
import { DisplayConditionsComponent } from './registration-form/display-conditions/display-conditions.component';
import { RegistrationFormService } from './registration-form.service';
import { RegistrationService } from './registration.service';

@NgModule({
  declarations: [
    SessionsListComponent,
    SessionsComponent,
    SessionsEditComponent,
    SessionsCreateComponent,
    WizardColComponent,
    WizardFormComponent,
    Step3Component,
    GenericLoginComponent,
    SessionsFeaturesComponent,
    SessionsUsersComponent,
    SessionsRegistrationComponent,
    SessionsCustomizationComponent,
    SessionsEmailComponent,
    SessionsLinksComponent,
    SessionsLinksComponent2,
    SessionsGenericLoginComponent,
    KonamiDirective,
    ShowHideComponent,
    RegistrationFormComponent,
    OrderByDatePipe,
    RepeatPipe,
    FriendlyPhonePipe,
    SessionsManageMeEventComponent,
    ReplayPublishComponent,
    DecodeUriPipe,
    VideoFileUploadComponent,
    StatsComponent,
    BarChartComponent,
    StatsNumberComponent,
    StatsHistogramComponent,
    SessionsCertificatesComponent,
    EventManagerComponent,
    AdditionalConfigurationComponent,
    SessionsRegistrationFormComponent,
    EditRegistrationFieldComponent,
    EditRegistrationFieldValuesComponent,
    EditRegistrationFieldCompanionsComponent,
    EditRegistrationFieldConditionsComponent,
    EditRegistrationFieldSingleConditionComponent,
    DisplayConditionsComponent,
  ],
  imports: [
    TagInputModule,
    router,
    HttpModule,
    CommonModule,
    ClipboardModule,
    PluginsModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    ArchwizardModule,
    NgPipesModule,
    PopoverModule.forRoot(),
    NgxTabsModule.forRoot(),
    BsDropdownModule.forRoot(),
    SharedModule,
    TabsModule,
    CustomizationModule,
    EmailModule,
    ModalModule.forRoot(),
    IboxtoolsModule,
    ImageImportModule,
    DatePickerModule,
    DragulaModule,
    TooltipModule.forRoot(),
    FileUploadModule,
    TagEditorModule,
    EvaEditorModule
  ],
  providers: [
    AuthGuard,
    SessionsService,
    ShortUrlService,
    UsersService,
    WizardService,
    SessionResolver,
    SessionsResolver,
    ShowHideComponent,
    PhoneNumberService,
    ThemeResolver,
    VideoService,
    TagsService,
    StatsService,
    CertificatesService,
    ParticipantsService,
    RegistrationFormService,
    RegistrationService,
  ],
  exports: []
})
export class SessionsModule {}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/sessions.module.ts